import React from 'react';
import Styles from './MeuFinanciamentoParcelas.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import WhiteButton from '@/components/atoms/WhiteButton';

function MeuFinanciamentoParcelas() {
  return (
    <>
      <section id="meu-financiamento-antecipar">
        <ContainerHome24>
          <h3 className="antecipar-titulo">Confira as vantagens de antecipar suas parcelas</h3>
          <p className="antecipar-paragrafo">
            Ao antecipar suas parcelas de financiamento na Santander Financiamentos, você pode
            receber diversas vantagens.
          </p>
          <div className="antecipar-content">
            <div className="item">
              <img src="assets/meu-financiamento/ic_checking_account.svg" alt="parcelas" />
              <p className="antecipar-paragrafo p1">Você terá desconto em suas parcelas.</p>
            </div>
            <div className="item is-mob">
              <img src="assets/meu-financiamento/ic_calendar_check.svg" alt="calendario" />
              <p className="antecipar-paragrafo">
                Você termina seu contrato de financiamento antes.
              </p>
            </div>
            <div className="item is-desk">
              <img src="assets/meu-financiamento/ic_calendar_check.svg" alt="calendario" />
              <p className="antecipar-paragrafo">
                Você termina seu contrato de financiamento antes.
              </p>
            </div>
            <div className="item is-mob">
              <img src="assets/meu-financiamento/ic_car.svg" alt="pagamentos" />
              <p className="antecipar-paragrafo">
                Você poderá realizar um novo financiamento em menos tempo.
              </p>
            </div>
            <div className="item is-desk">
              <img src="assets/meu-financiamento/ic_car.svg" alt="pagamentos" />
              <p className="antecipar-paragrafo">
                Você poderá realizar um novo financiamento em menos tempo.
              </p>
            </div>
          </div>
          <WhiteButton
            href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:3a-dobra&int_campaign=antecipar-parcelas"
            target="_blank"
            className="btn-antecipar is-mob"
          >
            Saiba mais
          </WhiteButton>
          <WhiteButton
            className="btn-antecipar is-desk"
            href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:3a-dobra&int_campaign=antecipar-parcelas"
            target="_blank"
          >
            Antecipar parcelas
          </WhiteButton>
          <img
            className="antecipar-calendar is-mob"
            src="assets/meu-financiamento/ic_calendar.svg"
            alt="pagamentos"
          />
          <img
            className="antecipar-calendar is-desk"
            src="assets/meu-financiamento/ic_calendar-desk.svg"
            alt="pagamentos"
          />
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>

      <section className="antecipar-wpp">
        <ContainerHome24 className="antecipar-wpp-content">
          <div>
            <h3 className="antecipar-wpp-titulo">
              Você também pode antecipar ou gerar a 2ª via do seu <br />
              <b>boleto pelo WhatsApp</b>
            </h3>
            <p className="antecipar-wpp-paragrafo">
              Você sabia que é possível gerar seus boletos através do WhatsApp?
              <br />
              Basta{' '}
              <a
                href="https://www.santander.com.br/hotsite/santanderfinanciamentos/sandbox.html?redirect=https://api.whatsapp.com/send?phone=551140049090&text=Ol%C3%A1%20Santander%20Financiamentos"
                target="_blank"
              >
                acessar seu WhatsApp<div className="is-desk"> Web</div>
              </a>{' '}
              e emitir a 2ª via de forma rápida e fácil.
              <br />
              <br />
              Praticidade e segurança de onde estiver.
            </p>
          </div>
          {/* <img src="assets/boleto/qrcode-whatsapp-santander.png" alt="qrcode" /> */}
        </ContainerHome24>
      </section>
    </>
  );
}

export default MeuFinanciamentoParcelas;
